export const MONTH_UNIT = 30;

export const LEADTIME_WEEK_UNIT = 7;
export const LEADTIME_MONTH_UNIT = 30;

export const DAY_STD = 86400000;

export const MONTH_NUM_OF_BIZDAYS = 300; // month表示の時のデフォルト稼働日
export const DAY_NUM_OF_BIZDAYS = 180; // day表示の時のデフォルト稼働日

export const YEAR_TO_MONTH = 12;
export const MAXIMUM_DAY = 31; // その月で考えうる最大の日
export const MINIMUM_DAY = 1; // その月で考えうる最小の日

export const DEFAULT_WEEK_SCALE = 7;
export const DEFAULT_MONTH_SCALE = 30;

export const FORECAST_LENGTH = 4; // 内示の長さ
export const SUPPLIER_FORECAST_LENGTH = 6; // 仕入先内示の長さ
export const FORECAST_LENGTH_IN_MODAL = 26; // 内示の長さ（モーダル内）

export const FORECAST_INITIAL_VALUE = 0; // 内示の初期値
export const STOCK_INITIAL_VALUE = 0; // 在庫の初期値
export const SALES_RESULTS_INITIAL_VALUE = 0; // 販売実績の初期値
export const ARRIVAL_INITIAL_VALUE = 0; // 入荷の初期値

export const DISPLAY_ANNOUNCE_INITIAL_LENGTH = 4; // テーブルに表示する内示列の列数の初期値

export const INVALID_NUMBER = -1; // 何かしらの数値が無効だった場合に代わりに-1を持たせておく

export const UNIT_OF_DAY = '日(単位)';
export const UNIT_OF_WEEK_SIMPLE = '週(単位)';
export const UNIT_OF_WEEK = '週間(単位)';
export const UNIT_OF_MONTH_SIMPLE = '月(単位)';
export const UNIT_OF_MONTH = 'ヶ月(単位)';

export const TABLE_CONTENTS_PER_PAGE = 30; // テーブルの1ページに表示するアイテム数

export const PERCENTAGE_BASE_OF_TABLE_COLUMN_WIDTH = 100; // テーブルの列幅を比率から計算する際の基準となる値

export const STEP_OF_CHANGE_DATE = '1'; // 日付変更時のステップ数
export const STEP_OF_CHANGE_MONTH = '0.1'; // 月変更時のステップ数
export const MIN_OF_CHANGE_DATE = 0; // 日付変更時の最小値
export const MAX_OF_CHANGE_DATE = 999; // 日付変更時の最大値

// 内示調整の倍率の最大値
export const STEP_OF_ADJUST_ANNOUNCE_RATE = 0.1;
export const MAX_OF_ADJUST_ANNOUNCE_RATE = 999.9;
export const MIN_OF_ADJUST_ANNOUNCE_RATE = 0.1;

export const MAX_OF_DISPLAY_FORECAST_IN_RECEIVE_FORECAST_PAGE = 24; // 受領内示ページで表示する内示の最大数、2年分
export const MAX_OF_DISPLAY_FORECAST_IN_DIFF_LAST_MONTH_PAGE = 12; // 内示前月差異ページで表示する内示の最大数

// 未管理に関連するフィルタータイプ名
export const UNMANAGED_FILTER_TYPE_NAMES = [
  'UNMANAGED_BUSINESS_ARRIVAL_AMOUNT', // 入荷数量
  'UNMANAGED_BUSINESS_SUPPLIER_NUMBER', // 仕入先コード
  'UNMANAGED_BUSINESS_SUPPLIER_NAME', // 仕入先名
  'UNMANAGED_BUSINESS_BUSINESS_NUMBER', // 商品コード
  'UNMANAGED_BUSINESS_BUSINESS_NAME', // 商品名
  'UNMANAGED_BUSINESS_PACKAGE', // 容量
  'UNMANAGED_BUSINESS_WAREHOUSE_NUMBER', // 置場コード
  'UNMANAGED_BUSINESS_WAREHOUSE', // 置場名
  'UNMANAGED_BUSINESS_INVENTORY_AMOUNT', // 在庫数量
  'UNMANAGED_BUSINESS_ANNOUNCE_AMOUNT-1', // 内示数量1（当月）
  'UNMANAGED_BUSINESS_ANNOUNCE_AMOUNT-2', // 内示数量2(1ヶ月後)
  'UNMANAGED_BUSINESS_ANNOUNCE_AMOUNT-3', // 内示数量3(2ヶ月後)
  'UNMANAGED_BUSINESS_CUSTOMER_NUMBER', // 売上先コード
  'UNMANAGED_BUSINESS_CUSTOMER_NAME', // 売上先名
  'UNMANAGED_BUSINESS_SALES_DESTINATION_NUMBER', // 送り先コード
  'UNMANAGED_BUSINESS_SALES_DESTINATION_NAME', // 送り先名
  'UNMANAGED_BUSINESS_SALES_RESULTS_AMOUNT', // 販売実績数量
  'UNMANAGED_BUSINESS_END_USER', // エンドユーザ名
  'UNMANAGED_BUSINESS_MANUFACTURER', // メーカー名
] as const;

/**
 * 内示遍歴で使用するフィルタータイプ名
 */
export const FORECAST_TIMELINE_FILTER_TYPE_NAMES = [
  'FORECAST_TIMELINE_STAFF_NAME',
  'FORECAST_TIMELINE_WAREHOUSE_CODE',
  'FORECAST_TIMELINE_WAREHOUSE',
  'FORECAST_TIMELINE_SUPPLIER_CODE',
  'FORECAST_TIMELINE_SUPPLIER_NAME',
  'FORECAST_TIMELINE_BUSINESS_CODE',
  'FORECAST_TIMELINE_BUSINESS_NAME',
  'FORECAST_TIMELINE_PACKAGE_AMOUNT',
  'FORECAST_TIMELINE_CUSTOMER_CODE',
  'FORECAST_TIMELINE_CUSTOMER_NAME',
  'FORECAST_TIMELINE_SALES_DESTINATION_CODE',
  'FORECAST_TIMELINE_SALES_DESTINATION_NAME',
] as const;

// apiを叩いて一覧データを取得する必要があるフィルターアイテムのタイプ
export const FETCH_REQUIRED_FILTER_TYPE_NAMES = [
  'SUPPLIER_NAME',
  'SUPPLIER_CODE',
  'BUSINESS_NAME',
  'WAREHOUSE_CODE',
  'CUSTOMER_CODE',
  'SALES_DESTINATION_CODE',
  'PACKAGE_AMOUNT',
  'WAREHOUSE',
  'STAFF_NAME',
  'BUSINESS_CODE',
  'CUSTOMER_NAME',
  'SALES_DESTINATION_NAME',
  'ORDER_ID',
  'ORDER_DATE',
  'DESIRED_DELIVERY_DATE',
  'ORDER_NUMBER',
  'DELIVERY_DATE',
  'ORDER_AMOUNT',
  'GROUP_ID',
  'UNIT',
  'STANDARD_INVENTORY_INDEX_MIN',
  'STANDARD_INVENTORY_INDEX_MAX',
  'MOQ',
  'LEAD_TIME',
  'MANUFACTURER',
  'END_USER',
  'SUPPLIER_FORECAST_RESPONSIBLE_USER',
  'CUSTOMER_FORECAST_RESPONSIBLE_USER',
  'FORECAST_FOR_RECEIPT_RESPONSIBLE_USER',
  'FORECAST_FOR_RECEIPT_ID',
  'FORECAST_FOR_RECEIPT_NAME',
  'ORDER_PACKAGE',
  'ORDER_GROUP_ID',
  'AGGREGATE_BUSINESS_GROUP_FILTER_INFO',
  'ORDER_GROUP_NAME',
  'INVOICE_NUMBER',
  'DESTINATION_NAME',
  'UNMATCHED_SUPPLIER_NUMBER',
  'UNMATCHED_SUPPLIER_NAME',
  'UNMATCHED_BUSINESS_NUMBER',
  'UNMATCHED_BUSINESS_NAME',
  'UNMATCHED_WAREHOUSE_NUMBER',
  'UNMATCHED_WAREHOUSE',
  'UNMATCHED_ORDER_NUMBER',
  'UNMATCHED_ORDER_ISSUED_NUMBER',
  ...UNMANAGED_FILTER_TYPE_NAMES,
  ...FORECAST_TIMELINE_FILTER_TYPE_NAMES,
] as const;

const INVENTORY_DASHBOARD_FILTER_TYPE_NAMES = [
  'INVENTORY_DASHBOARD_DISPLAY_DATA_TYPE',
  'INVENTORY_DASHBOARD_DISPLAY_DATA_COLUMN',
  'INVENTORY_DASHBOARD_ANNOUNCE_ACCURACY',
];

export const NO_FETCH_REQUIRED_FILTER_TYPE_NAMES = [
  'RECEIVED_FORECAST_NAME',
  'DISPLAY_MONTH',
  'DISPLAY_YEAR_MONTH',
  'LEAD_TIME_UNIT',
  'STD_INVENTORY_INDICES_UNIT',
  'AGGREGATE_BUSINESS_GROUP',
  'FORECAST_FOR_RECEIPT',
  'ORDER_GROUP',
  'USER',
  'LAST_CHECKED_AT',
  ...INVENTORY_DASHBOARD_FILTER_TYPE_NAMES,
] as const;

export const DATE_RANGE_FILTER_TYPES = ['ORDER_DATE', 'DESIRED_DELIVERY_DATE', 'DELIVERY_DATE'] as const;

export const COLOR_SEMANTIC_PRIMARY = '#1E92EF'; //カラーコード:SemanticPrimary

// 許可されるファイル名の一覧
/**
 * 在庫表ファイルの許可されるファイル名の一覧
 */
export const ALLOWED_MASTER_DATA_FILE_NAMES = ['在庫表', 'MasterData'] as const;
/**
 * 内示ファイルの許可されるファイル名の一覧
 */
export const ALLOWED_FORECAST_FILE_NAMES = ['内示', 'Forecast'] as const;
/**
 * 日別内示ファイルの許可されるファイル名の一覧
 */
export const ALLOWED_DAILY_FORECAST_FILE_NAMES = ['日別内示', 'DailyForecast'] as const;
/**
 * 販売実績ファイルの許可されるファイル名の一覧
 */
export const ALLOWED_SALES_RESULT_FILE_NAMES = ['販売実績', 'SalesResult'] as const;
/**
 * 入荷ファイルの許可されるファイル名の一覧
 */
export const ALLOWED_ARRIVAL_FILE_NAMES = ['入荷', 'Arrival'] as const;
/**
 * 在庫ファイルの許可されるファイル名の一覧
 */
export const ALLOWED_STOCK_FILE_NAMES = ['在庫', 'Stock'] as const;
/**
 * 発注ファイルの許可されるファイル名の一覧
 */
export const ALLOWED_ORDER_FILE_NAMES = ['発注取込', 'Order'] as const;
/**
 * 値が未設定であることを示す値
 */
export const UNASSIGNED_COLUMN = 'UNASSIGNED_COLUMN';

/**
 * 英語月名から月番号へのマッピング
 * NOTE: 受領用内示出力の英語ヘッダーと同じです
 */
export const ENGLISH_MONTH_TO_NUMBER: Record<string, number> = {
  jan: 1,
  'jan.': 1,
  january: 1,
  feb: 2,
  'feb.': 2,
  february: 2,
  mar: 3,
  'mar.': 3,
  march: 3,
  apr: 4,
  'apr.': 4,
  april: 4,
  may: 5,
  'may.': 5,
  jun: 6,
  'jun.': 6,
  june: 6,
  jul: 7,
  'jul.': 7,
  july: 7,
  aug: 8,
  'aug.': 8,
  august: 8,
  sep: 9,
  'sep.': 9,
  september: 9,
  oct: 10,
  'oct.': 10,
  october: 10,
  nov: 11,
  'nov.': 11,
  november: 11,
  dec: 12,
  'dec.': 12,
  december: 12,
};
